import FileView from '../../../../../components/FileView/FileView';
export default FileView;
